import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import md5 from "md5";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { fakeAuthContext } from "../Router";
import { handleInitLoginCookies } from "../common/session";
// Customed component
import { getCookie } from "../common/session";
import FilterCompanyList from "./FilterCompanyList";

// APIs
const getProductBrandListAPI = "/api/product/brand/list";
const getOpUserGroupBrandRelationURL = "/OP/user/getOpUserGroupBrandRelation";
const getIamAccessTokenUrl = "/api/v0/iam/getAccessToken"; // IAM 取得 Access Token 的 URL

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  versionText: {
    color: "darkgreen",
    textAlign: "center",
    fontSize: "16px",
    marginTop: theme.spacing(2),
  },
  bulletinBoard: {
    backgroundColor: "#f8f9fa",
    padding: theme.spacing(2),
    margin: theme.spacing(2, 0),
    borderRadius: 10,
    border: "1px solid #ddd",
    textAlign: "center",
    cursor: "pointer",
  },
}));

export default function Login(props) {
  const fakeAuth1 = React.useContext(fakeAuthContext);
  const classes = useStyles();
  const history = useHistory();
  // eslint-disable-next-line

  const ckOpName = getCookie("op_name");
  const authorization = axios.defaults.headers.common["X-RenZheng"];

  const [id, setId] = useState("");
  const [pwd, setPwd] = useState("");
  const [otp, setOtp] = useState("");

  const [filterCompanyOptionStatus, setFilterCompanyOptionStatus] =
    useState(false);
  const [productBrandList, setProductBrandList] = useState([]);
  const [version, setVersionContent] = useState(""); // Show version number
  const [bulletinDetails, setBulletinDetails] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [oldLoginOption, setOldLoginOption] = useState(false);

  useEffect(() => {
    axios.post("/api/bulletin/bulletin")
      .then(response => {
        setBulletinDetails(response.data);
      })
      .catch(error => {
        console.error("Error fetching bulletin details:", error);
      });
  }, []);

  useEffect(() => {
    axios.post("/api/bulletin/version")
      .then(response => {
        setVersionContent(response.data);
      })
      .catch(error => {
        console.error("Error fetching version no:", error);
      });
  }, []);

  // State operator
  const closeFilterCompanyList = () => {
    setFilterCompanyOptionStatus(false);
  };

  // Data handler
  const chooseFilterCompany = useCallback((brandSn) => {
    // getData(brandSn);
    localStorage.setItem("filterCompany", brandSn);
  }, []);

  const handleBulletinClick = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleOldLoginOption = () => {
    setOldLoginOption(true);
  };

  const handleGoToIAM = () => {
    // HTTP method GET: Redirect to IAM login page
    let redirectToIam = `https://${process.env.REACT_APP_IAM_BASE_URL}/auth/realms/B2E/protocol/openid-connect/auth?response_type=code&redirect_uri=${process.env.REACT_APP_IAM_REDIRECT_URL}&client_id=${process.env.REACT_APP_IAM_CLIENT_ID}&scope=ldap%20openid`;

    console.log("Redirecting to IAM:" + redirectToIam);
    window.location.href = redirectToIam;
  }

  const isValidInput = (input) => {
    // 僅允許字母和數字及特殊符號
    const regex = /^[a-zA-Z0-9_~!@#$%^&*()+=]*$/;
    return regex.test(input);
  };

  const sanitizeInput = (input) => {
    // 移除可能的路徑替代字和其他不安全字符
    return input.replace(/(\.\.\/|~\/|<|>)/g, "");
  };

  // 使用 useCallback 包裝 redirect
  const redirect = useCallback(() => {
    console.log("準備轉至 /backoffice/Orders");
    axios.post("/OP/user/getUserById", {
      "OperatorId": id
    }).then(function (req) {
      if (req.data !== undefined) {
        //console.log(req.data);
        var errMsg = "";
        if (req.data["Employee_No"] === "") {
          errMsg += "員工編號為空\n";
        }
        if (req.data["Email"].includes("cht.com.tw") === false) {
          if (req.data["OfficeManagerEmpNo"] === "") {
            errMsg += "單位主管員工編號為空\n";
          }
          if (req.data["Office"] === "") {
            errMsg += "所屬單位為空\n";
          }
        }
        if (errMsg !== "") {
          errMsg = "依據公司規範, 需於\"管理者\"內自身的資訊內填入帳號資訊, 以下資訊請盡速填寫:\n" + errMsg;
          alert(errMsg);
        }
      }
      history.replace("/backoffice/Orders");
    }).catch(function (err) {
      console.log(err);
      history.replace("/backoffice/Orders");
    });
  }, [history, id]); // 確保 history 和 id 在依賴陣列中

  // Load initial data with useEffect
  useEffect(() => {
    if (ckOpName && authorization) {
      var postData = {};
      postData["OpName"] = ckOpName;
      axios
        .post(getProductBrandListAPI, postData)
        .then(function (res) {
          if (res.data !== undefined) {
            // console.log(res);
            setProductBrandList(res.data);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }, [ckOpName, authorization]);

  function login() {
    axios
      .post("/api/v0/login", {
        id: id,
        pwd: md5(pwd),
        otp: otp,
      })
      .then(function (response) {
        loginSuccess(response);
      })
      .catch(function (error) {
        loginError(error);
      });
  }

  const loginSuccess = useCallback((response) => {
    handleInitLoginCookies(response.data.Session, response.data.Name, response.data.GroupSn);
    setId(response.data.Name);
    fakeAuth1.isAuthenticated = true;
    axios
      .post(getOpUserGroupBrandRelationURL, {
        operatorId: response.data.Name,
      })
      .then(function (res) {
        if (res.data !== undefined) {
          var brandCount = 0;
          var brandSn = 0;
          for (var i = 0; i < res.data.length; ++i) {
            if (res.data.IsMemberOfThisBrand !== undefined) {
              if (res.data.IsMemberOfThisBrand === true) {
                brandCount += 1;
                brandSn = res.data[i]["BrandSn"];
              }
            }
          }
          if (brandCount === 1) {
            chooseFilterCompany(brandSn);
            redirect();
          } else {
            setFilterCompanyOptionStatus(true);
          }
        } else {
          setFilterCompanyOptionStatus(true);
        }
      })
      .catch(function (err) {
        console.log(err);
        alert("資料庫異常, 登入所有廠牌");
        chooseFilterCompany(0);
        redirect();
      });
  }, [chooseFilterCompany, redirect, fakeAuth1]); // 確保 id 在依賴陣列中

  function loginError(error) {
    console.error("登入錯誤:", error);
    console.log(error.response);
    //alert(error.response.data);
    console.error("Login error:", error); // 在控制台記錄錯誤
    if (error.response) {
      console.error("狀態碼:", error.response.status);
      console.error("回應資料:", error.response.data);
    }
    alert("登入失敗，請稍後再試。"); // 顯示通用錯誤訊息
  }

  function getOtp() {
    axios
      .post("/api/v0/getOtp", {
        id: id,
        pwd: md5(pwd),
      })
      .then(function (response) {
        alert("OTP 已發送,請在5分鐘內登入");
      })
      .catch(function (error) {
        let errMsg = "發生錯誤，請稍後再試";

        // 判斷是否是 HTTP 回應錯誤
        if (error.response) {
          const res = error.response;

          // 1. 嘗試取得後端回傳的錯誤訊息
          if (res.data) {
            if (typeof res.data === "string") {
              // 若是純字串
              errMsg = res.data;
            } else if (typeof res.data === "object") {
              // 若是 JSON 格式
              errMsg =
                res.data.error ||
                res.data.message ||
                JSON.stringify(res.data);
            }
          } else {
            errMsg = `伺服器回應錯誤（狀態碼: ${res.status}）`;
          }
        } else if (error.request) {
          // 沒有收到回應
          errMsg = "伺服器未回應，請檢查網路或稍後再試";
        } else {
          // 其他錯誤
          errMsg = "發送請求時發生錯誤：" + error.message;
        }

        /*if (error.response && error.response.data) {
          // 若後端回傳是純字串而非 JSON
          if (typeof error.response.data === "string") {
            errMsg = error.response.data;
          } else if (typeof error.response.data === "object") {
            // 若後端是 json 回傳 { error: "xxx" }
            errMsg = error.response.data.error || JSON.stringify(error.response.data);
          }
        }*/

        alert(errMsg);
      });
  }

  function showAdminLogin() {
    if (process.env.REACT_APP_MODE === "development") {
      // cheat login API
      function loginAdmin() {
        axios
          .post("/api/v0/cheatLogin", {})
          .then(function (response) {
            handleInitLoginCookies(
              response.data.Session,
              response.data.Name,
              response.data.GroupSn
            ).then(() => {
              fakeAuth1.isAuthenticated = true;
              setId("admincms");

              axios
                .post(getOpUserGroupBrandRelationURL, {
                  operatorId: response.data.Name,
                })
                .then(function (res) {
                  // console.log(response.data.Name);
                  if (res.data !== undefined) {
                    var brandCount = 0;
                    var brandSn = 0;
                    for (var i = 0; i < res.data.length; ++i) {
                      // console.log(res.data[i]["IsMemberOfThisBrand"]);
                      if (res.data[i]["IsMemberOfThisBrand"] !== undefined) {
                        if (res.data[i]["IsMemberOfThisBrand"] === true) {
                          brandCount += 1;
                          brandSn = res.data[i]["BrandSn"];
                        }
                      }
                    }
                    // console.log(brandCount);
                    if (brandCount === 1) {
                      chooseFilterCompany(brandSn);
                      redirect();
                    } else {
                      setFilterCompanyOptionStatus(true);
                    }
                  } else {
                    setFilterCompanyOptionStatus(true);
                  }
                })
                .catch(function (err) {
                  console.log(err);
                  alert("資料庫異常, 登入所有廠牌");
                  chooseFilterCompany(0);
                  redirect();
                });

              // Move this to this end of brand choosing
              // history.replace("/backoffice");
            });
          })
          .catch(function (error) {
            //console.log(error);
            //console.log(error.response);
            if (error !== undefined && error.response !== undefined && error.response.data !== undefined) {
              alert(error.response.data);
            }
          });
      }

      // return cheat login button
      return (
        <Grid container spacing={3}>
          <Grid item xs>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.submit}
              onClick={loginAdmin}
            >
              ------
            </Button>
          </Grid>
        </Grid>
      );
    } else {
      return <React.Fragment />;
    }
  }

  const hasLoginRef = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code || hasLoginRef.current) return;

    hasLoginRef.current = true; // 確保只跑一次

    const doLogin = async () => {
      try {
        const res = await axios.post(getIamAccessTokenUrl, {
          clientId: process.env.REACT_APP_IAM_CLIENT_ID,
          redirectUri: process.env.REACT_APP_IAM_REDIRECT_URL,
          code,
        }, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        });

        const data = res.data;
        if (data?.Session && data?.Name && data?.GroupSn) {
          loginSuccess({ data });
          history.replace(window.location.pathname);
        } else {
          console.error("IAM 回傳資料缺失", data);
          alert("IAM 登入失敗：資料不完整");
        }
      } catch (error) {
        loginError(error);
      }
    };

    doLogin();
  }, [history, loginSuccess]);

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>CSP</Avatar>
        <Typography component="h1" variant="h5">
          Login ({process.env.REACT_APP_MODE})
        </Typography>
        <div className={classes.bulletinBoard} onClick={handleBulletinClick}>
          <Typography variant="h6">{"公告: 當月更新(詳細請點擊)！"}</Typography>
        </div>
        <Dialog open={dialogOpen} onClose={handleDialogClose}>
          <DialogTitle>公告詳細更新內容</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {bulletinDetails.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              關閉
            </Button>
          </DialogActions>
        </Dialog>

        <Grid container spacing={3} className={classes.submit} style={{ display: oldLoginOption ? 'none' : 'block' }}>
          <Grid item xs={12}><Button onClick={handleGoToIAM} color="primary" fullWidth variant="contained" > IAM 登入 </Button></Grid>
          <Grid item xs={12}><Button onClick={handleOldLoginOption} color="secondary" fullWidth variant="contained"> 舊登入 </Button></Grid>
        </Grid>

        <form className={classes.form} noValidate hidden={!oldLoginOption}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="管理者帳號"
            name="id"
            id="email"
            autoComplete="off"
            autoFocus
            value={id}
            onChange={(event) => {
              const value = event.target.value;
              if (isValidInput(value)) {
                setId(sanitizeInput(event.target.value));
              }
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="管理者密碼"
            name="password"
            type="password"
            id="password"
            autoComplete="off"
            value={pwd}
            onChange={(event) => {
              setPwd(event.target.value.replace(/[<>]/g, ""));
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label="OTP"
            name="otp"
            id="otp"
            autoComplete="off"
            value={otp}
            onChange={(event) => {
              setOtp(event.target.value.replace(/[<>]/g, ""));
            }}
          />
          <Grid container spacing={3}>
            <Grid item xs>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={login}
              >
                登入系統
              </Button>
            </Grid>
            <Grid item xs>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                className={classes.submit}
                onClick={getOtp}
              >
                發送 OTP
              </Button>
            </Grid>
          </Grid>

          {showAdminLogin()}

          <Grid container spacing={3}>
            <Grid item xs>
              <Typography className={classes.versionText} variant="body2" color="textSecondary" align="center">
                Version: {version}
              </Typography>
            </Grid>
          </Grid>
        </form>
      </div>
      <FilterCompanyList
        open={filterCompanyOptionStatus}
        closeList={closeFilterCompanyList}
        chooseFilterCompany={chooseFilterCompany}
        companyList={productBrandList}
        redirect={redirect}
      />
    </Container>
  );
}
